import React, { FC } from "react";
import { getImageUrl } from "src/utils/getImageUrl";
import { ISoldInformation } from "src/@types/soldInformation";
import { ReactComponent as DoneIcon } from "src/assets/icons/done.svg";

interface Props {
  features: ISoldInformation[];
}

export const CloneFeatures: FC<Props> = ({ features }) => (
  <ul className="flex flex-col gap-2.5">
    {features.map(({ id, title, icon }) => (
      <li className="flex items-center gap-3" key={id}>
        <span className="flex items-center gap-3 w-full">
          <img src={getImageUrl(icon)} alt={title} />
          <span>{title}</span>
        </span>
        <DoneIcon />
      </li>
    ))}
  </ul>
);
